// 1024px represents the smallest size we will consider as desktop
// so the inverse of that is what we are considering mobile
// more context in comments of this Jira issue https://eastview.atlassian.net/browse/GEOW-732
export const MOBILE_MAX_WIDTH = 1024;
